import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import FileService from './file.service'

const useFile = () => {
  const fileService = new FileService()
  const baseCrud = useCrud(API_RESOURCE.FILE, fileService)

  const queryClient = useQueryClient()

  const useUploadFile = () => {
    return useMutation({
      mutationFn: (data) => fileService.uploadFile(data),
      onSuccess: (res) => {
        if (res?.message) {
          toast.info(res.message)
        }
        // queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }
  const useDownloadFile = () => {
    return useMutation({
      mutationFn: (id) => fileService.downloadFile(id),
    })
  }

  const useViewFileOnSharepoint = (id) => {
    const sharepointEnabled = import.meta.env.VITE_SHAREPOINT_TENDER_LINK_ENABLED !== 'false'
    return useQuery({
      queryKey: baseCrud.queryKey.detail(id),
      queryFn: () => fileService.getFileDetailOnSharepoint(id),
      enabled: id !== '' && sharepointEnabled,
    })
  }

  return {
    useFetchFile: baseCrud.useFetchOne,
    useRemoveFile: baseCrud.useRemove,
    useUploadFile,
    useDownloadFile: useDownloadFile,
    useViewFileOnSharepoint: useViewFileOnSharepoint,
  }
}

export default useFile
